export default {"src":"/_next/static/media/galvanlondon.ad5cabc6.svg","height":80,"width":184,"blurWidth":0,"blurHeight":0};